import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage, FormField } from '@vwfs-bronson/bronson-react';
import { FormikProps, useField, useFormikContext } from 'formik';
import { CatalogOpenRequestResponse, CategoryCatalogDropDown, CategoryDropDown } from '@cp-mx/common';
import { RequestInitialValues } from '../initialValues';
import { CustomSelectElement, CustomSelectUI } from './UI';

export type CategorySelectionProps = {
    currentCategorySelection?: string;
    contractProduct: string;
    setParentId: Function;
    setCategoryType: Function;
    dataCategory?: Array<CatalogOpenRequestResponse>;
};

export const CategorySelection: React.FC<CategorySelectionProps> = ({
    currentCategorySelection,
    contractProduct,
    setParentId,
    setCategoryType,
    dataCategory,
}) => {
    const { t } = useTranslation('open-request');
    const { setFieldValue }: FormikProps<RequestInitialValues> = useFormikContext();
    const [field, meta] = useField('categoryMainSelection');
    const listOptions: CustomSelectElement[] = [
        {
            optionKey: 'no-category',
            returnValue: '',
            displayValue: t('fields.category.placeholder'),
            content: <strong>{t('fields.category.placeholder')}</strong>,
        },
    ];
    const categoryResponse = dataCategory?.filter(category => {
        if (contractProduct && category.products.includes(contractProduct.trim())) {
            return category;
        }
    });

    const categorySelection = (): CategoryCatalogDropDown => {
        const arrayCategory: Array<CategoryDropDown> = [];
        categoryResponse?.forEach(elem => {
            arrayCategory.push({
                name: elem.description,
                id: elem.description,
            });
        });
        return {
            categories: arrayCategory,
        };
    };
    const setValueChange = (selectedCategory: string) => {
        if (selectedCategory !== currentCategorySelection) {
            const categorySelection = categoryResponse?.find(elem => elem.description === selectedCategory);
            setParentId(categorySelection?.id);
            setFieldValue('categoryMainSelection', selectedCategory);
            setFieldValue('categoryTypeSelection', '');
            setCategoryType(categorySelection?.category);
        }
    };

    const getOptions = () => {
        categorySelection().categories.forEach((category: CategoryDropDown) => {
            listOptions.push({
                optionKey: category.id,
                returnValue: category.id,
                displayValue: category.name,
                content: <strong>{category.name}</strong>,
            });
        });
        return listOptions;
    };
    return (
        <FormField type="select" testId={'category-selection'}>
            {getOptions().length > 1 && (
                <CustomSelectUI
                    label={t('fields.category.label')}
                    required
                    dropdownElements={listOptions}
                    onChange={setValueChange}
                    selectedKey={currentCategorySelection}
                />
            )}
            {!field.value && meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
        </FormField>
    );
};
